import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import Background from "./components/BackGround";
import AdminLogin from "./components/AdminLogin";
import TopBar from "./components/TopBar";
import Review from "./components/Review";
import MeetDoctor from "./components/MeetDoctor";
import Benifits from "./components/Benifits";
import Footer from "./components/Footer";
import LoginForm from "./components/LoginForm";
import NewClient from "./components/NewClient";
import Expertise from "./components/Expertise";
import BookAppointment from "./components/BookAppointment";
import AdminDashboard from "./components/AdminDashboard";
import DoctorHighlights from "./components/DoctorHighlights";
import SocialLinks from "./components/SocialLinks";
import logo from "./assets/logo.jpeg";
import AnimatedSection from "./components/IntersectionObserver";

/* ================= HOME PAGE ================= */

const HomePage = () => {
  const [activeForm, setActiveForm] = useState("login");
  const [clientData, setClientData] = useState(null);

  // FIX: Added safety checks to prevent "undefined" JSON errors
  useEffect(() => {
    try {
      const sessionData = sessionStorage.getItem("clientData");
      if (sessionData && sessionData !== "undefined" && sessionData !== "null") {
        const parsedData = JSON.parse(sessionData);
        setClientData(parsedData);
        setActiveForm("book-appointment");
      }
    } catch (err) {
      console.error("Session restoration failed", err);
      sessionStorage.removeItem("clientData"); // Clear corrupt data
    }
  }, []);

  const handleLoginSuccess = (data) => {
    // FIX: Extract the first user from the array returned by the API
    const user = Array.isArray(data) ? data[0] : data;
    if (user) {
      setClientData(user);
      setActiveForm("book-appointment");
      sessionStorage.setItem("clientData", JSON.stringify(user));
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem("clientData");
    setClientData(null);
    setActiveForm("login");
  };

  const handleRegisterSuccess = (data) => {
    // FIX: Handle array vs object for registration response
    const user = Array.isArray(data) ? data[0] : data;
    if (user) {
      setClientData(user);
      setActiveForm("book-appointment");
      sessionStorage.setItem("clientData", JSON.stringify(user));
    }
  };

  return (
    <div className="app-container">
      <Background />
      <div className="main-content">
        <TopBar />

        <section className="header-section">
          <div className="bgimg">
            <h1 className="main-title">
              DR SHIVANI's<br />HOUSE OF HOMOEOPATHY
            </h1>

            <h3 className="address">
              Milan Building, Rd Number 4,<br />
              Golibar, Santacruz East, Mumbai, Maharashtra
            </h3>
          </div>

          <div className="header-logo">
            <img src={logo} alt="Clinic Logo" />
          </div>

          <SocialLinks />

          {activeForm === "login" && (
            <LoginForm
              goToRegister={() => setActiveForm("new-client")}
              onLoginSuccess={handleLoginSuccess}
            />
          )}

          {activeForm === "new-client" && (
            <NewClient
              goBack={() => setActiveForm("login")}
              onRegisterSuccess={handleRegisterSuccess}
            />
          )}

          {activeForm === "book-appointment" && (
            <BookAppointment
              clientData={clientData}
              onLogout={handleLogout}
            />
          )}
        </section>

        <AnimatedSection>
        <Review
          title="Patient Reviews"
          subtitle="Rated 5⭐ by 20+ Patients on Google"
        />
        </AnimatedSection>

        <AnimatedSection>
        <section id="expertise">
          <Expertise />
        </section>
        </AnimatedSection>

        <AnimatedSection>
        <section id="meet">
          <MeetDoctor />
        </section>
        </AnimatedSection>

        <AnimatedSection>
        <DoctorHighlights />
        </AnimatedSection>

        <AnimatedSection>
        <section id="Benifits">
          <Benifits />
        </section>
        </AnimatedSection>

        <Footer />
      </div>
    </div>
  );
};

/* ================= ADMIN PROTECTED ROUTE ================= */
const ProtectedAdmin = () => {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(
    !!sessionStorage.getItem("adminAuth")
  );

  // If already logged in, show the Dashboard
  if (isAdminAuthenticated) {
    return <AdminDashboard onLogout={() => {
      sessionStorage.removeItem("adminAuth");
      setIsAdminAuthenticated(false);
    }} />;
  }

  // If NOT logged in, show the AdminLogin screen
  return (
    <AdminLogin 
      onClose={() => window.location.href = "/"} 
      onLoginSuccess={() => {
        sessionStorage.setItem("adminAuth", "true");
        setIsAdminAuthenticated(true);
      }} 
    />
  );
};


/* ================= MAIN APP ================= */

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<ProtectedAdmin />} />
      </Routes>
    </Router>
  );
};

export default App;
